import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExportManagerComponent } from './export-manager.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { SubscriptionGuard } from 'shared/subscription/subscription.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';
import { PreferencesResolver } from 'shared/preferences/preferences.resolver';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'export-manager',
        component: ExportManagerComponent,
        canActivate: [AuthGuard, SubscriptionGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-edit', 'repository'] },
        resolve: {
          permissions: PermissionsResolver,
          preferences: PreferencesResolver,
        },
      },
    ])
  ],
  exports: [RouterModule],
})
export class ExportManagerRoutingModule { }
